<template>
    <label class="relative block">
        <span class="hidden">Search</span>
        <input
            ref="input"
            v-model="model"
            aria-describedby="Search"
            class="block w-full border border-grey-light p-2 pr-12"
            placeholder="Search-text"
            type="text"
            @keydown.enter="performSearch">
        <button
            v-show="hasValue" aria-label="Perform Search"
            class="absolute inset-y-0 right-0 mr-6 text-grey px-2"
            type="button"
            @click.prevent="model=''">
            <font-awesome-icon icon="times"/>
        </button>
        <button
            aria-label="Perform Search"
            class="absolute inset-y-0 right-0 text-primary px-2"
            @click.prevent="performSearch">
            <font-awesome-icon icon="search"/>
        </button>
    </label>
</template>

<script>

import QS from "qs";

export default {

    data() {
        return {
            query: {},
            model: '',
        }
    },

    mounted() {
        this.setQuery();
    },

    methods: {
        inputHasFocus() {
            return this.$el.contains(document.activeElement);
        },
        setQuery() {
            this.query = QS.parse(this.$inertia.page.url.split('?')[1]);

            if (!this.inputHasFocus()) {
                this.model = _.get(this.query, 'search', '');
            }
        },
        performSearch() {

            if (this.onSearchPage() && this.model === this.query.search) {
                return;
            }

            let options = {
                method: 'get',
                data: {
                    search: this.model
                },
            };

            if (this.onSearchPage()) {
                options.only = ['posts'];
                options.preserveScroll = true;
            }

            this.$inertia.visit('/search', options);
        },
        onSearchPage() {
            return this.$inertia.page.component === 'Search'
        }
    },

    computed: {
        hasValue() {
            return this.model !== '';
        }
    },

    watch: {
        '$page'() {
            this.setQuery();
        }
    },
};

</script>
